export default __webpack_public_path__ + "images/Q2.93337bb.png";